const columns = [

  {
    text: 'BE-Mitarbeitende',
    align: 'start',
    sortable: true,
    cell:'Zueri9VbzNr',
    columnName: 'zueri9VbzNr',
    width:200,
    displaySize:'all', //all | mdAndDown | lgAndUp
  },

  {
    text: 'Dienst',
    align: 'center',
    sortable: true,
    cell:'DutyCellWithDetailView',
    columnName: 'z9Duty',
    width:160,
    displaySize:'all', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Dienst von - bis',
    align: 'center',
    sortable: true,
    cell:'FromTo',
    columnName: 'z9FromTo',
    width:220,
    displaySize:'all', //all | mdAndDown | lgAndUp
  },

  {
    text: 'Linie/Kurs',
    align: 'center',
    sortable: false,
    cell:'TextCell',
    columnName: 'z9Line',
    width:100,
    displaySize:'all', //all | mdAndDown | lgAndUp
  },
  // {
  //   text: 'Dienst von - bis',
  //   align: 'center',
  //   sortable: true,
  //   columnName: 'fromTo2',
  //   width: 190,
  //   displaySize:'all', //all | mdAndDown | lgAndUp
  // },
  //
  // {
  //   text: 'Linie/Kurs',
  //   align: 'end',
  //   sortable: true,
  //   columnName: 'lineP2',
  //   width: 80,
  //   displaySize:'all', //all | mdAndDown | lgAndUp
  // },
  {
    text: 'Bemerkung',
    cell:'MultiLineTextCell',
    columnName: 'remarks',
    sortable: true,
    align: 'start',
    displaySize:'all', //all | mdAndDown | lgAndUp
  },


];
export default columns;
